import { useCompanyId } from '@startuptools/common/react-wrapper';
import {
  OptionsSharesRegistrationDocument,
  useOptionsSharesRegistrationSuspenseQuery,
} from '../../../../../graphql/react-operations';
import { RegistrationToDoList } from '../../../../common/components/RegistrationToDoList';

export const StepNextStepsOsr = ({ optionsSharesRegistrationId }: { optionsSharesRegistrationId: string }) => {
  const companyId = useCompanyId();
  const { data } = useOptionsSharesRegistrationSuspenseQuery({
    variables: { id: optionsSharesRegistrationId, companyId },
  });

  return (
    <RegistrationToDoList
      optionsSharesRegistrationId={optionsSharesRegistrationId}
      completions={data.optionsSharesRegistration.todoCompletions}
      refetchQueries={[OptionsSharesRegistrationDocument]}
      todos={data.optionsSharesRegistration.todos}
    />
  );
};
